import 'css-chunksrc/client/common/projectsSelection/zones/zone/projects/styles.scss';export default {
  "projects": "_projects_1gibh_1"
};